import { render } from "./PropsReceiving.vue?vue&type=template&id=06f3cde4"
import script from "./PropsReceiving.vue?vue&type=script&lang=js"
export * from "./PropsReceiving.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__